import { Leads } from '../../../api/Endpoints/Leads'
import { useEffect, useState } from 'react';
import { Box, Button, Card, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/PageHeader/PageHeader';
import StatusSelector from '../../../components/Form/Status';
import { Waveform } from '@uiball/loaders';
import StatusLIstFunction from '../../../components/CommonFunctions/statusLIst';
import SearchField from '../../../components/TableElements/SearchField';
import FilterBadges from '../../../components/FilterBadge/FilterBadges';
import FilterListIcon from '@mui/icons-material/FilterList';
import { toast } from 'react-toastify';



export default function BannedLeads() {
  const [logPopupOpen, setLogPopupOpen] = useState(false);
  const [selectedLogLead, setSelectedLogLead] = useState(null);

  const [unbanDialogOpen, setUnbanDialogOpen] = useState(false);
  const [unbanLeadData, setUnbanLeadData] = useState(null);
  const [unbanProjectIds, setUnbanProjectIds] = useState([]);
  const [unbanning, setUnbanning] = useState(false);
  const [unbanProjects, setUnbanProjects] = useState([]);

  const [banMoreDialogOpen, setBanMoreDialogOpen] = useState(false);
  const [banMoreProjectIds, setBanMoreProjectIds] = useState([]);
  const [banningMore, setBanningMore] = useState(false);
  const [availableProjects, setAvailableProjects] = useState([]);
  const [availableProjectsLoading, setAvailableProjectsLoading] = useState(false);

  const [unbanAllLoading, setUnbanAllLoading] = useState(false);

  const handleViewLogs = (lead) => {
    setSelectedLogLead(lead);
    setLogPopupOpen(true);
  };

  const handleCloseLogs = () => {
    setLogPopupOpen(false);
    setSelectedLogLead(null);
  };

  const handleUnbanClick = (lead) => {
    const projectNames = lead?.banned_project_names || [];
    const bannedProjectIds =
      typeof lead?.banned_project_ids === "string"
        ? JSON.parse(lead.banned_project_ids)
        : lead?.banned_project_ids || [];
    const projects = bannedProjectIds.map((id, i) => ({
      id,
      name: projectNames[i] || `Project ${id}`
    }));
    setUnbanProjects(projects);
    setUnbanLeadData(lead);
    setUnbanProjectIds(bannedProjectIds);
    setUnbanDialogOpen(true);
  };

  const handleUnbanClose = () => {
    setUnbanDialogOpen(false);
    setUnbanLeadData(null);
    setUnbanProjectIds([]);
    setUnbanProjects([]);
  };

  const handleUnbanProjectToggle = (projectId) => {
    setUnbanProjectIds(prev =>
      prev.includes(projectId)
        ? prev.filter(id => id !== projectId)
        : [...prev, projectId]
    );
  };

  const handleUnbanConfirm = async () => {
    setUnbanning(true);
    try {
      const payload = { id: unbanLeadData.id, project_ids: unbanProjectIds };
      const response = await Leads.unbanLead(payload);
      if (response.data.status) {
        toast.success("Lead has been unbanned successfully.", { autoClose: 1000 });
        handleUnbanClose();
        fetchBannedLeads();
      } else {
        toast.error("Failed to unban lead. Please try again.", { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again later.", { autoClose: 2000 });
    } finally {
      setUnbanning(false);
    }
  };

  const handleUnbanAll = async () => {
    setUnbanAllLoading(true);
    try {
      const payload = { id: unbanLeadData.id, is_ban: 0 };
      const response = await Leads.unbanLead(payload);
      if (response.data.status) {
        toast.success("Lead has been unbanned from all projects.", { autoClose: 1000 });
        handleUnbanClose();
        fetchBannedLeads();
      } else {
        toast.error("Failed to unban lead. Please try again.", { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again later.", { autoClose: 2000 });
    } finally {
      setUnbanAllLoading(false);
    }
  };

  const handleBanMoreClick = async () => {
    setBanMoreProjectIds([]);
    setBanMoreDialogOpen(true);
    setAvailableProjectsLoading(true);
    try {
      const response = await Leads.getProjects();
      const allProjects = response.data.projects || [];
      const rawIds = unbanLeadData?.banned_project_ids || [];
      const bannedIds = (typeof rawIds === "string" ? JSON.parse(rawIds) : rawIds).map(id =>
        typeof id === 'string' ? Number(id) : id
      );
      setAvailableProjects(allProjects.filter(p => !bannedIds.includes(Number(p.id))));
    } catch (error) {
      console.log(error);
      setAvailableProjects([]);
    } finally {
      setAvailableProjectsLoading(false);
    }
  };

  const handleBanMoreClose = () => {
    setBanMoreDialogOpen(false);
    setBanMoreProjectIds([]);
  };

  const handleBanMoreToggle = (projectId) => {
    setBanMoreProjectIds(prev =>
      prev.includes(projectId)
        ? prev.filter(id => id !== projectId)
        : [...prev, projectId]
    );
  };

  const handleBanMoreConfirm = async () => {
    setBanningMore(true);
    try {
      const rawIds = unbanLeadData?.banned_project_ids || [];
      const existingIds = (typeof rawIds === "string" ? JSON.parse(rawIds) : rawIds).map(id =>
        typeof id === 'string' ? Number(id) : id
      );
      const allIds = [...new Set([...existingIds, ...banMoreProjectIds])];
      const payload = { id: unbanLeadData.id, project_ids: allIds };
      const response = await Leads.unbanLead(payload);
      if (response.data.status) {
        toast.success("Lead banned from selected projects.", { autoClose: 1000 });
        handleBanMoreClose();
        handleUnbanClose();
        fetchBannedLeads();
      } else {
        toast.error("Failed to ban lead. Please try again.", { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again later.", { autoClose: 2000 });
    } finally {
      setBanningMore(false);
    }
  };

  const getLogsForLead = (lead) => {
    return lead?.lead_ban_logs || [];
  }

  const columns = [
    {
      field: 'name',
      headerName: 'Customer Name',
      width: 140,
      renderCell: (params) => (
        <Typography sx={{ whiteSpace: 'break-spaces', color: '#6f6f6f' }}>
          {params.row.name}
        </Typography>
      ),
    },
    {
      field: 'phone',
      headerName: 'Phone',
      width: 140,
      renderCell: (params) => (
        <Typography sx={{ color: '#6f6f6f' }}>
          {params.row.phone_number || params.row.mobile || '-'}
        </Typography>
      ),
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      renderCell: (params) => (
        <Typography sx={{ color: '#6f6f6f' }}>
          {params.row.email || '-'}
        </Typography>
      ),
    },
    // {
    //   field: 'project_name',
    //   headerName: 'Project',
    //   width: 200,
    //   renderCell: (params) => (
    //     <Typography sx={{ color: '#6f6f6f' }}>
    //       {params.row?.project?.name || '-'}
    //     </Typography>
    //   ),
    // },
    {
      field: 'banned_date',
      headerName: 'Banned Date',
      width: 130,
      renderCell: (params) => {
        const date = params.row.banned_at || params.row.created_at;
        return (
          <Typography sx={{ color: '#6f6f6f' }}>
            {date ? moment(date).format('DD-MM-YYYY') : '-'}
          </Typography>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 220,
      sortable: false,
      renderCell: (params) => (
        <>
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleViewLogs(params.row)}
          sx={{ mr: 1 }}
        >
          View Logs
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => handleUnbanClick(params.row)}
        >
          Unban
        </Button>
        </>
      ),
    },
  ];

  const { watch, formState: { errors }, control, Controller, setValue, reset } = useForm({});

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [loading, setLoading] = useState(false);
  const [bannedLeads, setBannedLeads] = useState([]);
  const [serachEntry, setSearchEntry] = useState('');
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [filterData, setFilterData] = useState({
    from: '',
    to: '',
    assing_to_users: '',
    lead_source: '',
    project_id: '',
    crm_status: '',
  });
  const { statusList, fetchStatusList } = StatusLIstFunction();

  const fetchBannedLeads = () => {
    setLoading(true);
    const params = {
      page: parseInt(paginationModel.page) + 1,
      filter: serachEntry || undefined,
      from_date: filterData.from || undefined,
      to_date: filterData.to || undefined,
      assigned_users: filterData?.assing_to_users || undefined,
      crm_status: filterData?.crm_status || undefined,
      lead_source: filterData?.lead_source || undefined,
      project_id: filterData?.project_id || undefined,
    };
    Leads.getBanLead(params).then(response => {
      setBannedLeads(response.data);
      setLoading(false);
    }).catch(error => {
      console.log(error.message);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchBannedLeads();
  }, [paginationModel, serachEntry, filterData]);

  useEffect(() => {
    fetchStatusList();
  }, []);

  // const handleFilter = () => {
  //   setFilterData({
  //     from: watch('from') ? moment(watch('from')).format('DD-MM-YYYY') : undefined,
  //     to: watch('to') ? moment(watch('to')).format('DD-MM-YYYY') : undefined,
  //     assing_to_users:
  //       watch('assing_to_users') &&
  //       watch('assing_to_users').map((assignUser) => assignUser.id),
  //     lead_source:
  //       watch('lead_source') &&
  //       watch('lead_source').map((leadSource) => leadSource.name),
  //     project_id:
  //       watch('project_id') &&
  //       watch('project_id').map((project) => project.id),
      
  //   });
  //   setShowFilterPopup(false);
  // };

  const closeFilterBadge = (filterName) => {
    const resetMap = {
      from: null,
      to: null,
      assing_to_users: null,
      lead_source: null,
      project_id: null,
      crm_status: null,
    };
    setFilterData((prev) => ({ ...prev, [filterName]: '' }));
    setValue(filterName, resetMap[filterName]);
  };

  const handleSearchEntry = (event) => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    setSearchEntry(event.target.value);
  };

  const clearSerachInput = () => {
    setSearchEntry('');
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const leadsData = bannedLeads?.leads || bannedLeads;
  const total = leadsData?.total || 0;
  const rows = leadsData?.data || [];

  return (
    <div class="page-cntr">
      <div class="lead-table archived-table closed-page-cntr">
        {/* {showFilterPopup && (
          <LeadFilter
            open={showFilterPopup}
            setOpen={setShowFilterPopup}
            watch={watch}
            control={control}
            reset={reset}
            handleFilter={handleFilter}
            setFilterData={setFilterData}
            setValue={setValue}
          />
        )} */}
        <div class="title-sec">
          <Card sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
            <PageHeader title={'Banned Leads'} total={!loading && total} />
            <SearchField
              clearSerachInput={clearSerachInput}
              name={'search'}
              placeholder="Name, Email or Phone"
              serachEntry={serachEntry}
              handleSearchEntry={handleSearchEntry}
            />
            {/* <div className="grid grid-cols-5 gap-[15px] header-icon-block">
              <Tooltip title="Filters" arrow>
                <IconButton
                  className="filter-btn-pop"
                  sx={{ mr: 2 }}
                  edge="end"
                  onClick={() => setShowFilterPopup(true)}
                >
                  <FilterListIcon />
                </IconButton>
              </Tooltip>
            </div> */}
          </Card>
        </div>
        <Grid container sx={{ display: 'flex', justifyContent: 'end' }}>
          {filterData?.from && (
            <FilterBadges
              label={'From'}
              value={filterData.from}
              handleClose={() => closeFilterBadge('from')}
            />
          )}
          {filterData?.to && (
            <FilterBadges
              label={'To'}
              value={filterData.to}
              handleClose={() => closeFilterBadge('to')}
            />
          )}
          {filterData?.assing_to_users?.length > 0 && (
            <FilterBadges
              label={'Assigned User'}
              value={`${filterData.assing_to_users.length} option selected`}
              handleClose={() => closeFilterBadge('assing_to_users')}
            />
          )}
          {/* {filterData?.lead_source?.length > 0 && (
            <FilterBadges
              label={'Lead Source'}
              value={`${filterData.lead_source.length} option selected`}
              handleClose={() => closeFilterBadge('lead_source')}
            />
          )} */}
          {filterData?.project_id?.length > 0 && (
            <FilterBadges
              label={'Project'}
              value={`${filterData.project_id.length} option selected`}
              handleClose={() => closeFilterBadge('project_id')}
            />
          )}
          {filterData?.crm_status?.length > 0 && (
            <FilterBadges
              label={'Status'}
              value={`${filterData.crm_status.length} option selected`}
              handleClose={() => closeFilterBadge('crm_status')}
            />
          )}
        </Grid>
        {loading ? (
          <Box sx={{ width: '100%', marginTop: 10, height: 80, display: 'flex', justifyContent: 'center' }}>
            <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
          </Box>
        ) : (
          <>
            {rows?.length > 0 ? (
              <Card sx={{ m: 0 }} variant="outlined" class="lead-table">
                {typeof rows === 'object' && (
                  <DataGrid
                    sx={{ width: '100%' }}
                    paginationMode="server"
                    rows={rows}
                    paginationModel={paginationModel}
                    columns={columns}
                    rowCount={total}
                    rowHeight={70}
                    autoHeight={true}
                    scrollbarSize={10}
                    density="comfortable"
                    onPaginationModelChange={setPaginationModel}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    disableExtendRowFullWidth
                  />
                )}
              </Card>
            ) : (
              <Box sx={{ width: '100%', marginTop: 15, height: 40, display: 'flex', justifyContent: 'center' }}>
                <Typography>Banned leads not found</Typography>
              </Box>
            )}
          </>
        )}
      </div>
      <Dialog open={logPopupOpen} onClose={handleCloseLogs} maxWidth="md" fullWidth>
        <DialogTitle sx={{ borderBottom: '1px solid #e5e7eb', pb: 2, mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Ban Logs
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary', mb: 1 }}>
            {selectedLogLead?.name || ''}
          </Typography>
          </Box>
          <Box>

            <Typography
              variant="caption"
              sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}
            >
              Banned Projects
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: 'text.primary' }}>
              {selectedLogLead?.banned_project_names?.length
                ? selectedLogLead.banned_project_names.join(', ')
                : 'Banned from All Projects'}
            </Typography>
          </Box>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {selectedLogLead && getLogsForLead(selectedLogLead).length > 0 ? (
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 0 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Submitted At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getLogsForLead(selectedLogLead).map((log, index) => (
                    <TableRow key={log.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{log.email || '-'}</TableCell>
                      <TableCell>{log.phone_number || '-'}</TableCell>
                      <TableCell>{log.created_at ? moment(log.created_at).format('DD-MM-YYYY') : '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography sx={{ py: 3, textAlign: 'center', color: '#6f6f6f' }}>
              No resubmission logs found for this lead.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogs} variant="outlined" color="inherit">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={unbanDialogOpen} onClose={handleUnbanClose} maxWidth="sm" fullWidth>
        <DialogTitle>Unban Lead - {unbanLeadData?.name || ''}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Uncheck any projects you want to <strong>keep banned</strong>, then confirm to unban the rest.
          </DialogContentText>
          <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
            {unbanProjects.length > 0 ? (
              unbanProjects.map((project) => (
                <FormControlLabel
                  key={project.id}
                  control={
                    <Checkbox
                      checked={unbanProjectIds.includes(project.id)}
                      onChange={() => handleUnbanProjectToggle(project.id)}
                    />
                  }
                  label={project.name}
                />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                This lead is banned from all projects.
              </Typography>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              Completely unban this lead from all projects
            </Typography>
            <LoadingButton
              onClick={handleUnbanAll}
              loading={unbanAllLoading}
              variant="contained"
              color="error"
              size="small"
            >
              Unban Lead
            </LoadingButton>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          {unbanProjects.length > 0 && (
            <Button onClick={handleBanMoreClick} variant="outlined" color="inherit">
              Ban More Projects
            </Button>
          )}
          <Box sx={{ ml: 'auto' }}>
            <Button onClick={handleUnbanClose} variant="outlined" color="inherit" sx={{ mr: 1 }}>Cancel</Button>
            <LoadingButton
              onClick={handleUnbanConfirm}
              loading={unbanning}
              variant="outlined"
              color="error"
              disabled={unbanProjectIds.length === 0}
            >
              {unbanProjectIds.length === unbanProjects.length
                ? 'Unban from All Projects'
                : 'Unban Selected Projects'}
            </LoadingButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog open={banMoreDialogOpen} onClose={handleBanMoreClose} maxWidth="sm" fullWidth>
        <DialogTitle>Ban from More Projects - {unbanLeadData?.name || ''}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Select additional projects to ban this lead from.
          </DialogContentText>
          <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
            {availableProjectsLoading ? (
              <Typography sx={{ textAlign: 'center', py: 2 }}>Loading projects...</Typography>
            ) : availableProjects.length > 0 ? (
              availableProjects.map((project) => (
                <FormControlLabel
                  key={project.id}
                  control={
                    <Checkbox
                      checked={banMoreProjectIds.includes(project.id)}
                      onChange={() => handleBanMoreToggle(project.id)}
                    />
                  }
                  label={project.name}
                />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                This lead is already banned from all available projects.
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBanMoreClose} variant="outlined" color="inherit">Cancel</Button>
          <LoadingButton
            onClick={handleBanMoreConfirm}
            loading={banningMore}
            variant="outlined"
            color="error"
            disabled={banMoreProjectIds.length === 0}
          >
            Ban Selected Projects
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}